import React from "react";
import classNames from "classnames";
import { SHEET_ACCOUNTING_FORMAT_NO_CURRENCY } from "../../../../common/helpers/sheet";

interface RenderCellProps {
    isSummary?: boolean;
    value: number;
}

export const TrialBalanceDownloadCell: React.FC<RenderCellProps> = ({
    isSummary,
    value,
}) => {
    const classes = classNames(
        "download-table__table__cell",
        "download-table__cell--right",
        {
            "download-table__cell--bold": isSummary,
            "download-table__cell--border-top": isSummary,
        },
    );

    return (
        <td className={classes} data-z={SHEET_ACCOUNTING_FORMAT_NO_CURRENCY}>
            {value === 0 ? null : value}
        </td>
    );
};
